<template>
  <p class="info-text-field-renderer">
    <InlineMarkdownText :text="campo.label" />
  </p>
</template>

<script setup lang="ts">
import { TIntegracaoCampoModel } from "../../@types/IntegracaoCampoModel";
import InlineMarkdownText from "./InlineMarkdownText.vue";

defineProps<{
  campo: TIntegracaoCampoModel;
}>();
</script>

<style lang="scss" scoped>
.info-text-field-renderer {
  margin: 0;
  font-size: 12px;
  line-height: 1.4;
  color: var(--p-color-text-secondary, #6b7280);
}
</style>
